module.exports = __webpack_public_path__ + "images/modern-5ff861729745e6cd73068fc15f8a2076.jpg";